<template>
  <div v-if="requiresProcessingTime">
    <BaseInputLabel
      v-if="showLabel"
      :text="$t('global.duration')"
      :info="$t('appointment.create.processing_time_hint')"
    />
    <div :class="$style.multipleDurations">
      <BaseInput
        v-model="part.durationSetup"
        type="number"
        unitLabel="minute"
        :minValue="0"
        :disabled="disabled"
      />
      <BaseInput
        v-model="part.durationProcessing"
        type="number"
        unitLabel="minute"
        :minValue="0"
        :disabled="disabled"
      />
      <BaseInput
        v-model="part.durationFinish"
        type="number"
        unitLabel="minute"
        :minValue="0"
        :disabled="disabled"
      />
    </div>
  </div>
  <BaseInput
    v-else
    v-model="part.duration"
    :label="showLabel ? $t('global.duration') : undefined"
    type="number"
    unitLabel="minute"
    :minValue="0"
    :disabled="disabled"
  />
</template>

<script
  lang="ts"
  setup
>
import type { AppointmentPartAttributes } from '@/types';

withDefaults(
  defineProps<{
    part: AppointmentPartAttributes;
    requiresProcessingTime: boolean;
    showLabel?: boolean;
    disabled?: boolean;
  }>(),
  {
    showLabel: false,
    disabled: false,
  },
);
</script>

<style
  lang="scss"
  module
>
.multipleDurations {
  display: flex;
  gap: $spacing * 0.25;

  & > * {
    flex: 1;
    min-width: 0;
  }
}
</style>
